export class Regex {
  public static EMAIL_REGEX = /^\s*(\*+|(([^\s@]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9*]+\.)+[a-zA-Z*]{2,63}))))\s*$/;
  public static NUMBER_REGEX = /^[0-9]*$/;
  public static DECIMAL_REGEX = /^(0|[1-9]\d*)(\.\d+)?$/;
  public static NAME = /^[a-zA-Z ]+$/;
  public static COUNTRY_CODE = /^\+[1-9]\d{0,3}$/;
  public static URL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
}
